module.exports = "/img/p4f-outline.svg?1e897ef386975ad992a3ed4cefd48563";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/p4f-outline.svg
// module id = CKbC
// module chunks = 75